// components/ConfigurationSelector.jsx

import React from 'react';

const ConfigurationSelector = ({
  copyOptions,
  selectedConfigurations,
  copyAll,
  onConfigurationChange,
  onCopyAllToggle,
  onStartCopy,
  onBack,
  isLoading,
}) => {
  const handleCheckboxChange = (configId, checked) => {
    // Prevent changing mandatory options
    const option = copyOptions.find(opt => opt.id === configId);
    if (option && option.mandatory) {
      return;
    }

    let newSelection;
    if (checked) {
      newSelection = [...selectedConfigurations, configId];
    } else {
      newSelection = selectedConfigurations.filter(id => id !== configId);
    }
    onConfigurationChange(newSelection);
  };

  const canProceed = selectedConfigurations.length > 0;

  const spinnerStyle = {
    width: '16px',
    height: '16px',
    border: '2px solid #ffffff',
    borderTopColor: 'transparent',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
    marginRight: '8px'
  };

  return (
    <div>
      <div style={{ marginBottom: '24px' }}>
        <button
          onClick={onBack}
          style={{
            display: 'flex',
            alignItems: 'center',
            color: '#3b82f6',
            fontSize: '14px',
            fontWeight: 'bold',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            marginBottom: '16px'
          }}
        >
          <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ marginRight: '4px' }}>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to Project Selection
        </button>

        <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>
          Select Configuration to Copy
        </h3>
        <p style={{ color: '#6b7280', fontSize: '14px' }}>
          Choose which configuration elements you want to copy to your new project.
        </p>
      </div>

      {/* Copy All Toggle */}
      <div style={{
        marginBottom: '24px',
        padding: '16px',
        backgroundColor: '#eff6ff',
        borderRadius: '8px'
      }}>
        <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={copyAll}
            onChange={(e) => onCopyAllToggle(e.target.checked)}
            style={{
              width: '16px',
              height: '16px',
              accentColor: '#3b82f6',
              marginRight: '12px'
            }}
          />
          <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#1e40af' }}>
            Copy All Configuration
          </span>
        </label>
        <p style={{ fontSize: '12px', color: '#1e40af', marginTop: '4px', marginLeft: '28px' }}>
          Select all available configuration options
        </p>
      </div>

      {/* Individual Configuration Options */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        maxHeight: '400px',
        overflowY: 'auto',
        marginBottom: '24px'
      }}>
        {copyOptions.map((option) => (
          <div key={option.id} style={{
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            padding: '16px',
            backgroundColor: option.mandatory ? '#f8f9fa' : 'white'
          }}>
            <label style={{ display: 'flex', alignItems: 'flex-start', cursor: option.mandatory ? 'default' : 'pointer' }}>
              <input
                type="checkbox"
                checked={selectedConfigurations.includes(option.id)}
                onChange={(e) => handleCheckboxChange(option.id, e.target.checked)}
                disabled={option.mandatory}
                style={{
                  width: '16px',
                  height: '16px',
                  accentColor: '#3b82f6',
                  marginRight: '12px',
                  marginTop: '2px',
                  cursor: option.mandatory ? 'default' : 'pointer'
                }}
              />
              <div style={{ flex: 1 }}>
                <div style={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#111827',
                  marginBottom: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  {option.label}
                  {option.mandatory && (
                    <span style={{
                      fontSize: '11px',
                      padding: '2px 6px',
                      backgroundColor: '#3b82f6',
                      color: 'white',
                      borderRadius: '4px',
                      fontWeight: 'normal'
                    }}>
                      MANDATORY
                    </span>
                  )}
                </div>
                <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                  {option.description}
                </div>
                <div style={{ fontSize: '11px', color: '#9ca3af' }}>
                  Tables: {Array.isArray(option.tableName)
                    ? option.tableName.join(', ')
                    : option.tableName}
                </div>
              </div>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConfigurationSelector;